/** 获取file大小的名称 */
export const fileSize = (value: string | null | number): string => {
  if (typeof value == 'string') {
    return value
  }
  if (value == null) {
    return '0 Bytes'
  }
  const unitArr = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']
  let index = 0
  const srcsize = parseFloat(`${value}`)
  index = Math.floor(Math.log(srcsize) / Math.log(1024))
  let size: string | number = srcsize / Math.pow(1024, index)
  //  保留的小数位数
  size = size.toFixed(2)
  return size + unitArr[index]
}
